import { Content } from "antd/es/layout/layout";
import { ReactNode, useEffect } from "react";
import { Col, Pagination, Row, Typography } from "antd";
import Header from "../Header";
import styles from "../dashboardLayout.module.less";
import { BreadcrumbItemType } from "../Header/header.types";
import C from "@/utils/constants";

const { Title } = Typography;

interface IContentWrapperProps {
  title?: string;
  hideTitle?: boolean;
  children: ReactNode;
  dataBreadCrumb?: Array<BreadcrumbItemType>;
  renderFilter?: ReactNode;
  headerContent?: ReactNode | JSX.Element;
  paginationEnable?: boolean;
  currentPage?: number;
  total?: number;
  onChangePage?: (page:number, pageSize:number) => void;
}

function ContentWrapper({
  title = "",
  hideTitle = false,
  children = null,
  dataBreadCrumb = [],
  renderFilter = null,
  headerContent = null,
  currentPage = 1,
  total,
  paginationEnable = false,
  onChangePage
}: IContentWrapperProps) {
  useEffect(() => {
    document.title = title || "Dashboard";
  }, [title]);

  return (
    <>
      <Header dataBreadCrumb={dataBreadCrumb || []} renderFilter={renderFilter} />
      <Content className={styles.contentWrapper}>
        {headerContent && <div className={styles.contentHeader}>{headerContent}</div>}
        <div id="content" className={headerContent ? styles.contentBody : styles.contentBodyNoneHeader}>
          {!hideTitle && title && (
            <Title
              level={5}
              style={{
                marginBottom: 20,
                color: "#234C66",
                textTransform: "uppercase",
              }}
            >
              {title}
            </Title>
          )}
          <div
            style={{
              maxWidth: "100%",
            }}
          >
            {children}
          </div>
        </div>
        {paginationEnable && (
          <Row className={styles.pagination} justify="end" align="middle" gutter={8}>
            <Col>
              <Pagination  onChange={onChangePage} current={currentPage} pageSize={C.PAGE_SIZE} total={total} showSizeChanger={false} />
            </Col>
          </Row>
        )}
      </Content>
    </>
  );
}

export default ContentWrapper;
